import React from "react";
import { FormattedMessage } from "react-intl";

import { Button } from "../../../../../../components/button/Button";
import { Icon } from "../../../../../../components/icon/Icon";

export const RulePopupActions = ({
  handleClose,
  handleSubmit,
  handleRemove,
  isEdit,
  allowDelete,
  isSubmitDisabled,
}) => {
  const submitTextKey = isEdit ? "save_changes" : "create_rule";

  return (
    <div className={"rule-popup__actions"}>
      <Button color={"secondary"} onClick={handleClose}>
        <FormattedMessage id={"cancel"} />
      </Button>
      <Button disabled={isSubmitDisabled} onClick={handleSubmit}>
        <FormattedMessage id={submitTextKey} />
      </Button>
      {isEdit && (
        <div className={"rule-popup__actions--right"}>
          <Button
            color={"destructive"}
            isOutline
            onClick={handleRemove}
            disabled={!allowDelete}
          >
            <Icon icon="fa-regular fa-trash color-danger" />
            <span>
              <FormattedMessage id={"delete_rule"} />
            </span>
          </Button>
        </div>
      )}
    </div>
  );
};
